import EpgChannel from "./epg-channel";
import EpgProgram from "./epg-program";
import EPGUtility from "./epg-utility";

export default class EPGParser {

    static getUTCDateFromString(airTime, timeSlot, addMin = 0) {
        let localDateFromString = new Date(airTime + " " + timeSlot);

        let retTime = new Date(
            Date.UTC(
                localDateFromString.getFullYear(),
                localDateFromString.getMonth(),
                localDateFromString.getDate(),
                localDateFromString.getHours(),
                localDateFromString.getMinutes()
            )
        );
        if (addMin > 0) {
            retTime.setTime(retTime.getTime() + addMin * 60000);
        }
        return retTime;
    }

    static async parseEPGData(channel: EpgChannel, data: any, dateRange: any) {
        return new Promise(resolve => {
            let epg_type = channel.epgType;
            if (epg_type === "publica" || epg_type === "publica-fawesome") {
                let epg = data.epg;
                channel.id = data.channel['repeat-programs']
                channel.repeatPrograms = data.channel['repeat-programs']
                channel.displayName = data.channel['display-name']
                channel.image = data.channel['channel-image']

                if (epg && epg.length > 0) {
                    channel.programList = this.generatePublicaEPGData(epg, dateRange);
                }
            }
            resolve(true)
        })
    }


    static generatePublicaEPGData(epg, dateRange: { startDate: Date, endDate: Date }): EpgProgram[] {
        let epgFiltered: EpgProgram[] = [];
        let prevProgram!: EpgProgram
        for (let j = 0; j < epg.length; j++) {
            
            let pObj = epg[j];
            if(pObj.duration > 120) {
                pObj.start_timeObj = EPGUtility.getDeviceCurrentDateTime(
                    pObj.start_time * 1000
                );
                pObj.end_timeObj = EPGUtility.getDeviceCurrentDateTime(
                    (pObj.start_time + pObj.duration) * 1000
                );
                
                if (EPGUtility.isDateInRange(pObj,dateRange)) {
                    const program: EpgProgram = new EpgProgram()
                    Object.assign(program, epg[j])

                    if (prevProgram && prevProgram.end_timeObj < program.start_timeObj) {
                        prevProgram.end_timeObj = new Date(program.start_timeObj)
                        prevProgram.duration = (prevProgram.end_timeObj - prevProgram.start_timeObj) / 1000
                    }
                    if (epgFiltered.length ==0 && program.start_timeObj > dateRange.startDate) {
                        const fillerProgram: EpgProgram = new EpgProgram()
                        fillerProgram.start_timeObj = dateRange.startDate
                        fillerProgram.end_timeObj = program.start_timeObj
                        fillerProgram.duration = (fillerProgram.end_timeObj - fillerProgram.start_timeObj)/1000
                        epgFiltered.push(fillerProgram);
                    }
                    epgFiltered.push(program);
                    prevProgram = program
                }
            }
        }
        if (prevProgram && prevProgram.end_timeObj < dateRange.endDate) {
            const endFillerEndProgram: EpgProgram = new EpgProgram()
            endFillerEndProgram.start_timeObj = prevProgram.end_timeObj
            endFillerEndProgram.end_timeObj = dateRange.endDate
            endFillerEndProgram.duration = (endFillerEndProgram.end_timeObj - endFillerEndProgram.start_timeObj)/1000
            epgFiltered.push(endFillerEndProgram);
        }

        // epgFiltered = epgFiltered.sort((a, b) => {
        //     return a.start_time - b.start_time;
        // });
        return epgFiltered;
    }
}
